module.exports = __webpack_public_path__ + "img/prize.fa8ca04a.svg";